(function($, Drupal, once) {
  'use strict';

  Drupal.behaviors.expand_cards = {
    attach: function(context, settings) {
      $(once('expand-cards', '.block-inline-blockexpanding-card-teasers')).each(function(block) {
        const $block = $(block);
        const blockId = 'ex-cards-' + $block.index();
        $block.attr('id', blockId);

        const getCardClass = (length) => {
          switch (length) {
            case 1:
              return 'one-card';
            case 2:
              return 'two-card';
            case 3:
              return 'three-card';
            default:
              return '';
          }
        };

        const $cardsTop = $block.find('.field-cards-top-row .field-item');
        const $cardsBottom = $block.find('.field-cards-bottom-row .field-item');

        $block.find('.field-cards-top-row').first().addClass(getCardClass($cardsTop.length));
        $block.find('.field-cards-bottom-row').first().addClass(getCardClass($cardsBottom.length));
      });
    }
  };
})(jQuery, Drupal, once);
